import { Component, OnInit, ViewChild } from "@angular/core";
import { interval } from 'rxjs';

@Component({
    selector: "app-finalizar-pedido.page",
    templateUrl: "./finalizar-pedido.page.html",
    styleUrls: ["./finalizar-pedido.page.scss"],
})
export class FinalizarPedidoPage {

    constructor() {
        //in 10 seconds do something
        interval(10000).subscribe(x => {
            window.close();
            window.location.href = 'https://www.google.es/';
        });
    }    

}
